import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sitemap-dashboard-cards',
  templateUrl: './sitemap-dashboard-cards.component.html',
  styleUrls: ['./sitemap-dashboard-cards.component.css']
})
export class SitemapDashboardCardsComponent {
  @Input() data: any = null;

  get statusClass() {
    if (!this.data || !this.data.status) return 'text-muted';
    return this.data.status === 200 ? 'text-success' : 'text-danger';
  }
}
